import React from "react";
import "./styles.scss";
import ProfilePicture from "../../shared/ProfilePicture";
import HvButton from "../../shared/HvButton";
import { Spinner } from "react-bootstrap";
import { ReactComponent as LinkUploadIcon } from "../../../shared/Svg/btn_add_url.svg";
import MusicUploaderIcon from "../../../shared/Svg/MusicUploaderIcon";
import VideoUploaderIcon from "../../../shared/Svg/VideoUploaderIcon";
import ImgUploaderIcon from "../../../shared/Svg/ImgUploaderIcon";
import PlusIcon from "../../../shared/Svg/PlusIcon";
import MediaUploader from "../../../shared/MediaUploader";
import { createPost } from "../../../../api/posts";
import { log_error } from "../../../../api";
import MediaTag from "../../shared/MediaTag";
import RollOver from "../../../RollOver";
import { connect } from "react-redux";
import { requestAuthUrl } from "../../../../api/twitter";
import _ from "lodash";
import ContentEditable from "../../shared/ContentEditable";
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";

const MAX_TWITTER_TEXT_POST_LENGTH = 280;
const isMobileDevice = isMobile;
class TweetBox extends React.Component {
  init_state = {
    body: {
      text: "",
      attachments: [],
    },
    post_to_twitter: (this.props.current_user && this.props.current_user.is_twitter_connected) || false,
    showMediaUploader: false,
    mediaUploaderType: undefined,
    error: null,
    isPosting: false,
    link: null,
    isUploading: false,
    embadedURL: null,
  };

  state = this.init_state;
  createPostHandler = async () => {
    if (this.state.embadedURL != null) {
      try {
        let url;
        try {
          url = new URL(this.state.embadedURL);
        } catch (_) {
          throw Error("Oops! Be sure to add a valid link with http:// or https:// in the beginning.");
        }

        if (url.protocol === "http:" || url.protocol === "https:") {
        } else {
          throw Error("Oops! Be sure to add a valid link with http:// or https:// in the beginning.");
        }
      } catch (error) {
        console.log(log_error(error));
        this.setState({ error: "Oops! Be sure to add a valid link with http:// or https:// in the beginning.", isPosting: false });
        return;
      }
    }

    this.setState({ error: null, isPosting: true });
    if (!this.state.body.text && !this.state.body.attachments.length > 0) return;
    if (this.fileInputRefernce.current && this.fileInputRefernce.current.files[0] && !this.state.body.attachments.length) return;
    try {
      const {
        data: { post },
      } = await createPost({
        post: {
          post_to_twitter: this.state.post_to_twitter,
          text: this.state.body.text,
          embaded_url: this.state.embadedURL,
          attachments: this.state.body.attachments.map((a) => ({
            id: a.id,
            type: a.type,
          })),
        },
      });
      this.props.onPostCreated(post);
      this.setState(this.init_state);
      this.resetTextarea();
    } catch (err) {
      console.log("err =>", err);
      const error = log_error(err) ? log_error(err) : err;
      this.setState({
        error: _.isArray(error) ? error[0] && error[0].message : error,
      });
    } finally {
      this.setState({ isPosting: false });
    }
  };

  textSetter = (e) => {
    this.setState({
      body: { ...this.state.body, text: e.target.value },
    });
  };

  setMediaUploaderType = (type) => {
    this.setState({
      mediaUploaderType: type,
    });
  };

  onUploaded = (medium) =>
    this.setState({
      body: {
        ...this.state.body,
        attachments: [medium, ...this.state.body.attachments],
      },
    });
  togglePostToTwitter = () => {
    this.setState({ post_to_twitter: !this.state.post_to_twitter }, () => {
      this.colorTextArea(!this.state.post_to_twitter);
    });
  };
  fileInputRefernce = React.createRef();

  fetchLink = async () => {
    if (!this.props.current_user || this.props.current_user.is_twitter_connected) return;
    try {
      let {
        data: { url },
      } = await requestAuthUrl();
      this.setState({ link: url });
    } catch (error) {
      console.log("error", error);
    }
  };

  componentDidMount() {
    this.fetchLink();
  }

  getPostCharLength = () => {
    const { text } = this.state.body;
    return text.length > MAX_TWITTER_TEXT_POST_LENGTH ? MAX_TWITTER_TEXT_POST_LENGTH : text.length;
  };

  setEndOfContenteditable = (el) => {
    var range, selection;
    if (document.createRange) {
      range = document.createRange();
      range.selectNodeContents(el);
      range.collapse(false);
      selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    } else if (document.selection) {
      range = document.body.createTextRange();
      range.moveToElementText(el);
      range.collapse(true);
      range.select();
    }
  };

  resetTextarea = () => {
    this.setState({ html: "" });
  };
  colorTextArea = (toggleTwitter) => {
    let textArea = document.getElementById("editable-textarea");
    const { text } = this.state.body;
    if (text.length < MAX_TWITTER_TEXT_POST_LENGTH || toggleTwitter) {
      if (toggleTwitter) {
        this.setState({ html: text.replace(/\n/g, "<br>") });
        return;
      }
    }
    var normalText = text.substring(0, MAX_TWITTER_TEXT_POST_LENGTH).replace(/\n/g, "<br>");
    var invalidText = text.substring(MAX_TWITTER_TEXT_POST_LENGTH).replace(/\n/g, "<br>");
    var result = normalText + '<span style="color:#F40000">' + invalidText + "</span>";
    this.setState({ html: result }, () => {
      this.setEndOfContenteditable(textArea);
    });
  };

  componentDidUpdate(_, prevState) {
    if (this.state.post_to_twitter && prevState.body.text !== this.state.body.text) {
      this.colorTextArea();
    }
  }

  isUploadingMedium = (isUploading) => this.setState({ isUploading });
  isEmbadedURL = (embadedURL) => this.setState({ embadedURL });

  render() {
    const isTweetBtnDisabled = this.state.isPosting || this.state.isUploading || !this.state.body.text;
    return (
      <div className="tweet-box p-4 my-4 m-md-4">
        <div className="media">
          <ProfilePicture className="mr-3" user={this.props.current_user} />
          <ContentEditable
            id="editable-textarea"
            tag="div"
            onChange={this.textSetter}
            className="tweet-area pt-2"
            html={this.state.html}
            placeholder="What would you like to share?"
          />
        </div>
        <div className="d-flex flex-column my-2">
          {this.state.body.attachments.length
            ? this.state.body.attachments.map((m) => <MediaTag className="preview-medium my-2" medium={m} showProgress />)
            : null}
        </div>
        <div className="ml-6">
          {alert && (
            <div className={`alert alert-${alert.class}`}>
              {Array.isArray(alert.text) ? alert.text.map((err) => <li>{err.message}</li>) : alert.text}
            </div>
          )}
        </div>
        <div className="ml-6">
          {(this.state.mediaUploaderType === "audio" ||
            this.state.mediaUploaderType === "video" ||
            this.state.mediaUploaderType === "image" ||
            this.state.mediaUploaderType === "link") && (
            <MediaUploader
              mediaUploaderType={this.state.mediaUploaderType}
              fileInputRefernce={this.fileInputRefernce}
              onUploaded={this.onUploaded}
              embadedURL={this.isEmbadedURL}
              isUploading={this.isUploadingMedium}
            />
          )}
        </div>
        {this.state.error && (
          <div className="alert alert-danger">
            <p className="font-weight-bold">
              {this.state.error.indexOf("reconnect it here") >= 0 ? (
                <>
                  There was an issue posting to your X account, please{" "}
                  <Link style={{ textDecoration: "underline" }} to="/settings">
                    reconnect it here
                  </Link>{" "}
                  and try again.
                </>
              ) : (
                this.state.error
              )}
            </p>
          </div>
        )}
        <div className="d-flex justify-content-between align-items-center">
          <div className="tweet-uploader">
            <div
              className="d-flex justify-content-between"
              // onClick={this.toggleMediaUploader}
            >
              <RollOver text="add audio">
                <MusicUploaderIcon
                  borderColor="#fff"
                  color="#333333"
                  onClick={() => {
                    this.state.mediaUploaderType === "audio" ? this.setMediaUploaderType(undefined) : this.setMediaUploaderType("audio");
                  }}
                />
              </RollOver>
              <RollOver text="add video">
                <VideoUploaderIcon
                  borderColor="#fff"
                  color="#333333"
                  onClick={() => {
                    this.state.mediaUploaderType === "video" ? this.setMediaUploaderType(undefined) : this.setMediaUploaderType("video");
                  }}
                />
              </RollOver>
              <RollOver text="add photo">
                <ImgUploaderIcon
                  borderColor="#fff"
                  color="#333333"
                  onClick={() => {
                    this.state.mediaUploaderType === "image" ? this.setMediaUploaderType(undefined) : this.setMediaUploaderType("image");
                  }}
                />
              </RollOver>
              <RollOver text="add link">
                <LinkUploadIcon
                  borderColor="#fff"
                  color="#333333"
                  onClick={() => {
                    this.state.mediaUploaderType === "link" ? this.setMediaUploaderType(undefined) : this.setMediaUploaderType("link");
                  }}
                />
              </RollOver>
            </div>
          </div>

          <div className="d-flex flex-row align-items-center">
            {this.state.post_to_twitter && (
              <p className={`charactes-counts m-0 mt-1 ${this.state.body.text.length > MAX_TWITTER_TEXT_POST_LENGTH ? "max-length-exceeded" : ""}`}>
                {this.getPostCharLength()}/{MAX_TWITTER_TEXT_POST_LENGTH}
              </p>
            )}
            <div
              style={isMobileDevice ? { transform: "scale(0.8)" } : {}}
              className={isMobileDevice ? "custom-control custom-switch" : "custom-control custom-switch mr-5"}
            >
              {this.props.current_user && !this.props.current_user.is_twitter_connected ? (
                <a href={this.state.link}>
                  <label className="custom-control-label" htmlFor="post-switch"></label>
                </a>
              ) : (
                <>
                  <input
                    type="checkbox"
                    checked={this.state.post_to_twitter}
                    onChange={this.togglePostToTwitter}
                    className="custom-control-input bg-dark"
                    id="post-switch"
                  />
                  <label className="custom-control-label" htmlFor="post-switch"></label>
                </>
              )}
            </div>

            {this.state.post_to_twitter && this.state.body.text.length > MAX_TWITTER_TEXT_POST_LENGTH ? (
              <RollOver text="your post is too long!" className="post-submit-btn">
                <HvButton type="button" id="create-post" className="btn bg-white text-primary disabled">
                  <PlusIcon color="#cf2d77" className="mr-3" />
                  <span>Post</span>
                </HvButton>
              </RollOver>
            ) : (
              <HvButton
                disabled={this.state.isPosting || (!this.state.body.text && !this.state.body.attachments.length)}
                type="button"
                id="create-post"
                className={`btn bg-white text-primary btn-md ${
                  this.state.isPosting || (!this.state.body.text && !this.state.body.attachments.length) ? "disabled" : ""
                }`}
                onClick={this.createPostHandler}
              >
                {this.state.isPosting ? (
                  <Spinner animation="border" variant="primary" size="sm" role="status" style={{ minWidth: "1rem", minHeight: "1rem" }} />
                ) : (
                  <PlusIcon color="#cf2d77" className="mr-3" />
                )}{" "}
                Post
              </HvButton>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default connect((a) => a)(TweetBox);
